import { ButtonType, ButtonWidget } from '@tableau/widgets';
import React from 'react';
import _ from 'underscore';

import { Messages } from '~src/codegen/Localize';
import { ISiteAuthenticationSettings, SiteAuthenticationSettingsService } from '~src/settings/siteAuthSettings/services/SiteAuthenticationSettingsService';
import { ConnectedExplorer } from '~src/spacesPlatform/components/Explorer/ConnectedExplorer';
import { SpaceContainerStyles } from '~src/spacesPlatform/style/SpaceContainerStyles';

import { IGroupSetInfo } from '../../models/IGroupSetInfo';


export type GroupSetGroupsSubspaceProps = GroupSetGroupsSubspaceOwnProps;

export interface GroupSetGroupsSubspaceOwnProps {
    readonly groupSet: IGroupSetInfo;
    readonly canSessionUserManageUsers: boolean;
    readonly addGroupsToGroupSet: (groupSet: IGroupSetInfo) => void;
}

interface GroupSetGroupsSubspaceState {
    readonly renderChildren: boolean;
    readonly siteAuthenticationSettings: ISiteAuthenticationSettings;
}

export class GroupSetGroupsSubspace extends React.Component<GroupSetGroupsSubspaceProps, GroupSetGroupsSubspaceState> {

    public constructor(props: GroupSetGroupsSubspaceProps) {
        super(props);
        this.state = {
            renderChildren: false, siteAuthenticationSettings: undefined
        };
    }

    public componentDidMount() {
        this.getSiteAuthenticationSettings();
    }

    public componentDidUpdate(prevProps: GroupSetGroupsSubspaceProps) {
        if (!this.state.renderChildren && !_.isUndefined(this.state.siteAuthenticationSettings)) {
            this.setState({renderChildren: true});
        }
    }

    public render() {
        if (this.state.renderChildren) {
            return (<>
            <div className={SpaceContainerStyles.SubplaceArea}>
                <ConnectedExplorer
                supportedDisplayModes={['list']}
                toolbarProps={{
                    supportFilterPanel: true,
                    toolbarVisibility: 'enabled',
                    toolbarContentSpecificControls: { beginning: this.addGroupsButton(this.props.groupSet, this.props.canSessionUserManageUsers, this.props.addGroupsToGroupSet) }
                }}/>
            </div>
            </>
            );
        } else {
            return (<><div></div>
            </>);
        }
    }

    private getSiteAuthenticationSettings = async () => {
        const siteAuthenticationSettings = await SiteAuthenticationSettingsService.getSiteAuthenticationSettings();
        this.setState({siteAuthenticationSettings});
    };


    private addGroupsButton(groupSet: IGroupSetInfo,
        canSessionUserManageUsers: boolean,
        addGroupsToGroupSet: (groupSet: IGroupSetInfo) => void): JSX.Element {
        if (canSessionUserManageUsers) {
          const handleClick = () => addGroupsToGroupSet(groupSet);
          return (
            <ButtonWidget
              children={Messages.addGroups()}
              buttonType={ButtonType.Outline}
              handleClick={handleClick}
              tb-test-id={'action-add-groups'}
              testId={'action-add-groups'}/>
          );
        }
        return null;
    }
}